import MockService from '@/services/atp-mock'
import * as types from '../mutations'

const state = {
  requesterParty: null,
  requesterParties: []
}

const getters = {
  requesterParty: (state) => state.requesterParty,
  requesterParties: (state) => state.requesterParties
}

const actions = {
  async createRequesterParty ({ commit }, payload) {
    const { gln } = payload
    const party = await MockService.createRequesterParty(gln)
    commit(types.CREATE_MOCK_REQUESTER_PARTY, party)
  },

  async updateRequesterPartyGTINS ({ commit }, payload) {
    const { gln, gtins = [] } = payload
    const party = await MockService.updateRequesterParty(gtins, gln)
    commit(types.UPDATE_MOCK_REQUESTER_PARTY, party)
  },

  async getRequesterPartyDetail ({ commit }, partyId) {
    const partyDetail = await MockService.getRequesterPartyDetail(partyId)
    commit(types.SET_REQUESTER_PARTY_DETAIL, partyDetail)
  },

  updateRequesterPartyDetail ({ commit }, partyDetail) {
    commit(types.SET_REQUESTER_PARTY_DETAIL, partyDetail)
  }
}

const mutations = {
  [types.CREATE_MOCK_REQUESTER_PARTY] (state, party) {
    state.requesterParty = party
  },

  [types.UPDATE_MOCK_REQUESTER_PARTY] (state, party) {
    state.requesterParty = {
      ...state.requesterParty,
      ...party
    }
  },

  [types.SET_REQUESTER_PARTY_DETAIL] (state, partyDetail) {
    state.requesterParty = partyDetail
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
